import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=d0fda7fe&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fda7fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0fda7fe')) {
      api.createRecord('d0fda7fe', component.options)
    } else {
      api.reload('d0fda7fe', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=d0fda7fe&scoped=true&", function () {
      api.rerender('d0fda7fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ubossBk/views/ticket2/ticket/Index.vue"
export default component.exports